module.exports = __webpack_public_path__ + "img/19.a9deec47.jpg";